// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"51d847da","574":"8bac1dd7","601":"134604e5","681":"7c3b4c56","687":"52fee56d"}[chunkId] + ".chunk.js";
};